import React, { useState } from "react";
function Card(props) {
    const [img] = useState(props.img);
    const [Title] = useState(props.Title);
    if (props.type === '1') {
        return (

            <div className="card flex justify-content-between"  onClick={() => props.Push.push(props.Url)}>
                <div className=" flex justify-content-between align-item-center">
                    <img src={img} alt="bulp" style={{ width: 65 }} />
                    <h4 className="count" style={{fontSize:20}}>{props.Count}</h4>
                </div>
                <div className=" flex justify-content-between align-item-center">
                    <h5 className="size-text">{Title}</h5>
                    <span className="material-icons">
                        keyboard_arrow_right
</span>
                </div>
            </div>

        );
    }
    else if (props.type === '2') {
        return (
            <div className="card flex"  onClick={() => props.Push.push(props.Url)}>
                <div className=" flex justify-content-between align-item-center">
                    <div className="align-item-center">
                        <img src={img} alt="bulp" style={{ width: 40,marginRight:7 }} />
                        <h5 className="size-text">{Title}</h5>
                    </div>
                    <div className="align-item-center">
                        
                        <h4 className="count">{props.Count}</h4>
                        <span className="material-icons">
                            keyboard_arrow_right
                        </span>
                    </div>


                </div>
            </div>
        );
    }
    else if (props.type === '3') {
        return (
            <div className={`card flex justify-content-center  `}   onClick={() => props.Push.push(props.Url)}>
                <div className=" flex justify-content-center align-item-center">
                    <img src={img} alt="bulp" style={Title ==='Observations' ? {width: 37} :{width:40} } />
                  
                </div>
                {Title && 
                <div className=" flex justify-content-center align-item-center">
                  <h5 className="size-text">{Title}</h5>

                </div>
           }
            </div>
        );
    }
    else if (props.type === '4') {
        return (
            <div className="card flex justify-content-between"  onClick={() => props.Push.push(props.Url)}>
                <div className=" flex justify-content-center align-item-center">
                    <img src={img} alt="bulp" style={Title ==='Observations' ? {width: 37} :{width:40} } />
                  
                </div>
                {Title && 
                <div className=" flex justify-content-center align-item-center">
                    <h5 className="size-text">{Title}</h5>
                    

                </div>
           }
            </div>
        );
    }
}
export default Card;